export default __webpack_public_path__ + "static/media/plan@2x.1dafb7df.png";